import { useState } from 'react';
import { fetchWithCSRF } from '../utils/csrfUtils';
import { useAuth } from '../context/AuthContext';
import supabase from '../supabaseClient';

const useAddRecipe = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { user, pgUser } = useAuth();

    const addRecipe = async (recipeData) => {
        if (!user || !pgUser) {
            return {
                success: false,
                message: 'You must be logged in to create a recipe'
            };
        }

        setIsLoading(true);
        try {
            // Get the current session for the auth token
            const { data: { session } } = await supabase.auth.getSession();
            if (!session?.access_token) {
                throw new Error('No valid session found');
            }

            const response = await fetchWithCSRF('/api/v1/recipe', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${session.access_token}`
                },
                body: JSON.stringify(recipeData),
            });

            const data = await response.json();
            console.log("Response data:", data);

            if (response.ok) {
                return { 
                    recipeId: data.recipeId, 
                    success: true, 
                    message: data.message 
                };
            } else {
                const errorData = await response.json();
                console.error('Failed to create recipe:', errorData);
                return { 
                    success: false, 
                    message: 'Failed to create recipe: ' + (errorData.message || 'Unknown error')
                };
            }
        } catch (error) {
            console.error('Error:', error);
            return {
                success: false,
                message: 'An error occurred while creating the recipe'
            };
        } finally {
            setIsLoading(false);
        }
    };

    return {
        addRecipe,
        isLoading
    };
};

export default useAddRecipe;
